import { useState, useEffect } from 'react';
import { Language } from '../types/language';

export const useLanguage = () => {
  const [language, setLanguage] = useState<Language>(() => {
    // Check localStorage first
    const saved = localStorage.getItem('iran-monitor-language');
    if (saved && (saved === 'en' || saved === 'fa')) {
      return saved as Language;
    }
    
    // Check browser language
    const browserLang = navigator.language.toLowerCase();
    if (browserLang.startsWith('fa') || browserLang.includes('persian')) {
      return 'fa';
    }
    
    return 'en'; // Default to English
  });

  useEffect(() => {
    localStorage.setItem('iran-monitor-language', language);
    
    // Update document direction and language
    document.documentElement.lang = language;
    document.documentElement.dir = language === 'fa' ? 'rtl' : 'ltr';
    
    // Update meta tags
    const metaLang = document.querySelector('meta[name="language"]');
    if (metaLang) {
      metaLang.setAttribute('content', language === 'fa' ? 'Persian' : 'English');
    }
    
    // Update Open Graph locale
    const ogLocale = document.querySelector('meta[property="og:locale"]');
    if (ogLocale) {
      ogLocale.setAttribute('content', language === 'fa' ? 'fa_IR' : 'en_US');
    }
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'fa' : 'en');
  };

  return { language, setLanguage, toggleLanguage };
};